import { FC, useState } from 'react';
import { Box, styled, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import { protocolsInfos, protocolTokensInfos } from 'config/constants/protocols';
import ChainsSelect  from './ChainsSelect';
import PartnerCard from './Cards/PartnerCard';
import TokenCard from './Cards/TokenCard';

const Container = styled(Box)(({ theme }) => ({
  position: 'relative',
  borderRadius: '20px',
  padding: '0px 32px',
  background: theme.palette.background.card,
  boxShadow:
    '0px 100px 77px rgba(0, 0, 0, 0.13), 0px 25.9935px 52.3711px rgba(0, 0, 0, 0.0989853), 0px 10.1608px 47.2956px rgba(0, 0, 0, 0.0902431), 0px 5.70356px 44.4605px rgba(0, 0, 0, 0.0829201), 0px 3.80638px 39.8596px rgba(0, 0, 0, 0.0717558), 0px 2.15748px 29.2214px rgba(0, 0, 0, 0.0505145)',

  [theme.breakpoints.up('xs')]: {
    padding: '0px 16px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '0px 32px',
  },
}));

interface ProtocolChainsProps {
    activeChain?: number
}

const ProtocolChains: FC<ProtocolChainsProps> = ({ activeChain }) => {
  const [isExpanded, setExpanded] = useState<boolean>(false);
  const { selectedChainId } = useAppSelector((state) => state.chain);

  const [selectedChain, setSelectedChain] = useState<number>(250);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const partnersProtocols = protocolsInfos
    .filter((row) => row?.finished === false)
    .filter((row) => row?.chainId === Number(selectedChainId))
    .map((row1) => {
      return {
        ...row1,
      };
    });
    const tokensProtocols = protocolTokensInfos
        .filter((row) => row?.chainId === Number(selectedChainId))
        .map((row1) => {
            return {
            ...row1,
            };
    });

  const handleSelectChain = ( chain: number ) => {
    setSelectedChain(chain)
    console.log(`Select new chain ${chain}`);
  };

  return (
    <>
        {/* <Container>
        <ChainsSelect selectedChain={selectedChain} selectChain={handleSelectChain}/>
        </Container> */}
        {/* partners simple */}
        <>{tokensProtocols && tokensProtocols.map((row: any) => <TokenCard key={row.name} tokenInfo={row} />)}</>
        {/* partners simple */}
        <>{partnersProtocols && partnersProtocols.map((row: any) => <PartnerCard key={row.name} partnerInfo={row} />)}</>
    </>
  );
};

export default ProtocolChains;
